export default {
  energy: "Energy",
  gas: "Gas",
  chilled_water: "Chilled Water",
  steam: "Steam",
  simulation: "Simulation"
};
